module.exports = __webpack_public_path__ + "img/t1.78c26b5.png";